import axisPointer from './tooltip.axisPointer'
import textStyle from './tooltip.textStyle'

export default {
  name: "tooltip",
  nickname: "提示",
  desc: "tooltip",
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc:
        '是否显示提示框组件，包括提示框浮层和 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.axisPointer">axisPointer</a>。',
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    trigger: {
      name: "trigger",
      nickname: "触发类型",
      desc: "触发类型。",
      value: "item",
      defaultValue: "item",
      type: "pureValue",
    },
    axisPointer,
    showContent: {
      name: "showContent",
      nickname: "显示内容",
      desc:
        '是否显示提示框浮层，默认显示。只需tooltip触发事件或显示axisPointer而不需要显示内容时可配置该项为<code class="codespan">false</code>。',
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    alwaysShowContent: {
      name: "alwaysShowContent",
      nickname: "总是显示内容",
      desc:
        '是否永远显示提示框内容，默认情况下在移出可触发提示框区域后 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.hideDelay">一定时间</a> 后隐藏，设置为 <code class="codespan">true</code> 可以保证一直显示提示框内容。',
      value: false,
      defaultValue: false,
    },
    triggerOn: {
      name: "triggerOn",
      nickname: "触发的条件",
      desc: "提示框触发的条件，可选：",
      value: "mousemove|click",
      defaultValue: "mousemove|click",
      type: "pureValue",
    },
    showDelay: {
      name: "showDelay",
      nickname: "显示延迟",
      desc:
        '浮层显示的延迟，单位为 ms，默认没有延迟，也不建议设置。在 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.triggerOn">triggerOn</a> 为 <code class="codespan">&#39;mousemove&#39;</code> 时有效。',
      value: 0,
      defaultValue: 0,
    },
    hideDelay: {
      name: "hideDelay",
      nickname: "隐藏演示",
      desc:
        '浮层隐藏的延迟，单位为 ms，在 <a target="__blank" href="https://echarts.apache.org/zh/option.html#tooltip.alwaysShowContent">alwaysShowContent</a> 为 <code class="codespan">true</code> 的时候无效。',
      value: 100,
      defaultValue: 100,
      type: "pureValue",
    },
    enterable: {
      name: "enterable",
      nickname: "可进入",
      desc:
        '鼠标是否可进入提示框浮层中，默认为false，如需详情内交互，如添加链接，按钮，可设置为 <code class="codespan">true</code>。',
      value: false,
      defaultValue: false,
    },
    renderMode: {
      name: "renderMode",
      nickname: "渲染模式",
      desc:
        '浮层的渲染模式，默认以 <code class="codespan">&#39;html</code> 即额外的 DOM 节点展示 tooltip；此外还可以设置为 <code class="codespan">&#39;richText&#39;</code> 表示以富文本的形式渲染，渲染的结果在图表对应的 Canvas 中（目前 SVG 尚未支持富文本），这对于一些没有 DOM 的环境（如微信小程序）有更好的支持。',
      value: "html",
      defaultValue: "html",
      type: "pureValue",
    },
    confine: {
      name: "confine",
      nickname: "confine",
      desc: "是否将 tooltip 框限制在图表的区域内。",
      value: false,
      defaultValue: false,
    },
    appendToBody: {
      name: "appendToBody",
      nickname: "appendToBody",
      desc: "从 4.7.0 开始支持。",
      value: false,
      defaultValue: false,
    },
    transitionDuration: {
      name: "transitionDuration",
      nickname: "移动动画",
      desc:
        "提示框浮层的移动动画过渡时间，单位是 s，设置为 0 的时候会紧跟着鼠标移动。",
      value: 0.4,
      defaultValue: 0.4,
      type: "pureValue",
    },
    position: {
      name: "position",
      nickname: "位置",
      desc: "提示框浮层的位置，默认不设置时位置会跟随鼠标的位置。",
    },
    formatter: {
      name: "formatter",
      nickname: "文本格式化",
      desc: "提示框浮层内容格式器，支持字符串模板和回调函数两种形式。",
    },
    backgroundColor: {
      name: "backgroundColor",
      nickname: "背景色",
      desc: "提示框浮层的背景颜色。",
      value: "rgba(50,50,50,0.7)",
      defaultValue: "rgba(50,50,50,0.7)",
      type: "pureValue",
    },
    borderColor: {
      name: "borderColor",
      nickname: "边框颜色",
      desc: "提示框浮层的边框颜色。",
      value: "#333",
      defaultValue: "#333",
      type: "pureValue",
    },
    borderWidth: {
      name: "borderWidth",
      nickname: "边框宽度",
      desc: "提示框浮层的边框宽。",
      value: 0,
      defaultValue: 0,
    },
    padding: {
      name: "padding",
      nickname: "内边距",
      desc:
        "提示框浮层内边距，单位px，默认各方向内边距为5，接受数组分别设定上右下左边距。",
      value: 5,
      defaultValue: 5,
      type: "pureValue",
    },
    textStyle,
    extraCssText: {
      name: "extraCssText",
      nickname: "额外CSS文本",
      desc: "额外附加到浮层的 css 样式。如下为浮层添加阴影的示例：",
    },
  },
  isExpandForce: true,
  menuIconType: "text",
  menuIcon: "TS",
}
